import React from 'react'
import classes from './CollapseDiv.module.css'

const CollapseDiv = (props)=>{
    let data = null
    console.log(props.data)
    data = props.data.map(index=>{
        if(index.charAt(0)==="U"&&index.charAt(1)==="n"&&index.charAt(2)==="i"&&index.charAt(3)==="t"){
            return(<p className={classes.title}>{index}</p>)
        }
    return (<p className={classes.content}>{index}</p>)
    console.log(data);
    })
    return(
        <div className={classes.container}>
        {data}
        </div>
    )
}
export default CollapseDiv
